import React, { Component } from 'react';
import { Col } from "react-bootstrap";
import { HorizontalBar } from "react-chartjs-2";
import { addDataOnBar } from '../modules/helpers';
import { MASTER_DASHBOARD_CHART_TYPE } from "../common/constants";

const thicknessSet = {
    labels: [],
    datasets: [
        {
            label: 'print',
            backgroundColor: 'rgba(75,192,192,1)',
            data: []
        }
    ]
};

export default class PrintDataThickness extends Component {
    constructor(props) {
        super(props);
    }

    resolveThicknessSet = () => {
        const thicknessData = this.props.thicknessData;
        const thicknessSetLabels = [];
        const thicknessSetData = [];
        for (let [key, value] of Object.entries(thicknessData)) {
            thicknessSetLabels.push(key);
            thicknessSetData.push(value);
        }
        thicknessSet.labels = thicknessSetLabels;
        thicknessSet.datasets[0].data = thicknessSetData;
    };

    render() {
        this.resolveThicknessSet();
        return (
            <Col lg={6} md={6} xs={12}>
                <HorizontalBar
                    data={thicknessSet}
                    getElementAtEvent={element => {
                        if (element.length === 0) {
                            return
                        }
                        const index = element[0]._index;
                        const label = element[0]._chart.data.labels[index];
                        const value = element[0]._chart.data.datasets[0].data[index];
                        this.props.handleChartsClick({
                            chartType: MASTER_DASHBOARD_CHART_TYPE.THICKNESS,
                            label,
                            value,
                        })
                    }}
                    options={{
                        title: {
                            display: true,
                            text: 'Thickness',
                            fontSize: 20
                        },
                        scaleBeginAtZero: true,
                        hover: {
                            animationDuration: 0
                        },
                        animation: {
                            onComplete: (chart) => {
                                addDataOnBar(chart, 12, 6)
                            }
                        }
                    }}
                />
            </Col>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/print-data-thickness.js